/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { I18nMessage } from "@i18n/next";
import {
  CommunityType,
  useRequestCommunitiesAdminCommunity,
} from "@packages/sdk";
import type { SidebarProps } from "@packages/ui";
import {
  cssMediaQueryMinWidthTablet,
  Sidebar,
  spacing,
  Text,
} from "@packages/ui";
import { useParams } from "next/navigation";

import { GroupsList } from "../GroupsList";

const baseStyles: Interpolation = {
  gap: spacing.xxs,
  paddingLeft: spacing.s,
  paddingRight: spacing.s,
};

const baseNestedViewStyles: Interpolation = {
  display: "none",
  [cssMediaQueryMinWidthTablet]: {
    display: "block",
  },
};

const headerStyles: Interpolation = {
  marginBottom: spacing.s,
  paddingBottom: spacing.s,
  paddingLeft: spacing.m,

  paddingRight: spacing.m,
  display: "none",
  [cssMediaQueryMinWidthTablet]: {
    display: "block",
  },
};

type ParishAdminDashboardGroupsSidebarProps = Omit<SidebarProps, "children">;

export const ParishAdminDashboardGroupsSidebar = ({
  state,
  ...props
}: ParishAdminDashboardGroupsSidebarProps) => {
  const { communityId, childCommunityId } = useParams<{
    communityId: string;
    childCommunityId: string;
  }>();

  const isInNestedView = childCommunityId !== undefined;
  const { query: queryCommunitiesAdminCommunity } =
    useRequestCommunitiesAdminCommunity({ id: parseInt(communityId) });

  return (
    <Sidebar
      state={state}
      css={[baseStyles, isInNestedView && baseNestedViewStyles]}
      {...props}
    >
      <Text type="headline" size="m" css={headerStyles}>
        <I18nMessage
          message={
            queryCommunitiesAdminCommunity.data?.type === CommunityType.network
              ? "community_detail_groups_screen_title"
              : "community_small_groups_title"
          }
        />
      </Text>
      <GroupsList communityId={parseInt(communityId)} />
    </Sidebar>
  );
};
